import React from 'react';
import { CheckBoxItem, Collapse } from '@/components';
import classNames from 'classnames';
import * as CheckBox from '@/components/Common/checkbox';
import { CateogyItemType } from '@/modules/preview-product/enum';
import { getKeyQueryString, removeEmptyObject } from '@/modules/preview-product/utils';
import { useRouter } from 'next/router';
import { RoutConfig } from '@/constant/routes';
import { QueryKey } from '@/modules/preview-product/constants';

export interface ListCategoryItem<T extends CheckBoxItem> {
	type?: CateogyItemType;
	extraQuery?: string;
	label: string;
	value: T;
	isCheck: boolean;
}

export interface ListCategoryProps<T extends CheckBoxItem> {
	className?: string;
	title: string;
	list: Array<ListCategoryItem<T>>;
}

const ListCategory = <T extends CheckBoxItem>({ className, title, list }: ListCategoryProps<T>) => {
	const { query, push } = useRouter();

	const handlePushQuery = (value: T, extraQuery?: string, option?: { reload: boolean }) => {
		const obj = {
			...query,
			...(extraQuery && {
				[extraQuery]: value,
			}),
			[QueryKey.category]: value,
		};
		const convertObj = removeEmptyObject(obj);

		option?.reload
			? push(RoutConfig.Base.previewProduct, RoutConfig.VN.previewProduct)
			: push(
					`${RoutConfig.Base.previewProduct}?${getKeyQueryString(convertObj)}`,
					`${RoutConfig.VN.previewProduct}?${getKeyQueryString(convertObj)}`,
					{
						shallow: true,
					},
			  );
	};

	return (
		<Collapse title={title}>
			<div className={classNames('flex flex-col space-y-[10px]', className)}>
				{list.length &&
					list.map(({ value, isCheck, label, type, extraQuery }, index) => {
						return (
							<div key={index}>
								{type === CateogyItemType.Square ? (
									<CheckBox.SquareCheckbox
										checked={isCheck}
										value={value}
										label={<p className={classNames(isCheck && 'font-bold')}>{label}</p>}
										onChange={(event) => handlePushQuery(event.target.value as T, extraQuery)}
									/>
								) : (
									<CheckBox.RadioCheckbox
										checked={isCheck}
										value={value}
										label={<p className={classNames(isCheck && 'font-bold')}>{label}</p>}
										onChange={(event) => handlePushQuery(event.target.value as T, extraQuery)}
									/>
								)}
							</div>
						);
					})}
			</div>
		</Collapse>
	);
};

export default ListCategory;
